import { Navigate, Outlet } from "react-router-dom";
import { useAuthContext } from "../../contexts/auth-contex";
//import permissionsStore from "../../store/permissions";

export const PublicRoutes = () => {
  const { user } = useAuthContext(); //persistÊncia de login
  //const { storageUser } = permissionsStore(); //Demais dados que são conseguidos no login, não são atualizados depois.

  if (user) {
    // if (storageUser?.accounts[0].credits === 0) {
    //   return <Navigate to="/credits" />;
    // }
    return <Navigate to="/home" />;
  }

  return <Outlet />;
};
